import fetch from 'isomorphic-unfetch'
import firebase from 'firebase'

export const call = (url, body, authToken) =>
  fetch(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: authToken ? `Bearer ${authToken}` : undefined,
    },
    body: body ? JSON.stringify(body) : undefined,
  })
    .then(resp => {
      if (resp.ok) {
        return resp
      }
      let error = new Error(resp.statusText)
      //@ts-ignore
      error.resp = resp
      throw error
    })
    .then(resp => resp.json())

export const callW = async (
  url: string,
  {
    method = 'GET',
    body,
    auth,
  }: { body?: Object; auth: firebase.User; method?: string },
) => {
  let authToken
  if (auth) {
    authToken = await auth.getIdToken()
  }

  const response = await fetch(url, {
    method: method || 'GET',
    body: body ? JSON.stringify(body) : undefined,
    headers: {
      'Content-Type': 'application/json',
      Authorization: authToken ? `Bearer ${authToken}` : undefined,
    },
  })

  if (!response.ok) {
    let error = new Error(
      `call() error: ${response.status} - ${response.statusText}`,
    )
    // @ts-ignore
    error.response = response
    throw error
  }

  return await response.json()
}

import fromUnixTime from 'date-fns/fromUnixTime'
import format from 'date-fns/format'

export const formatUnix = sec => format(fromUnixTime(sec), 'dd-MM-yyyy')

import { User } from '../../../types/RM'
export const isSubscriptionActive = (userData: User): boolean => {
  return userData.stripe.subscription_end > Math.floor(Date.now() / 1000)
}
